import React from 'react';
import cx from 'classnames';

import withStyles from '@mui/styles/withStyles';

import noteAssocGroupStyles from '../assets/jss/crm/components/noteAssocGroupStyles';

import { showAlert } from '../utils/utils';

import NoteSummary from './NoteSummary';
import AlertModal from './AlertModal';

/*
Call this with
  <NoteAssocGroup
    notes={array of notes}
    newNoteUiFunc={() => function that will open a UI for creating a note} //optional
    pageRefenderFunc={function to rerender page in case we delete a note}
  />
*/

class NoteAssocGroup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showNoteSummaries: false,
    };
  }

  toggleNotesVisibility() {
    this.setState({ showNoteSummaries: !this.state.showNoteSummaries });
  }

  showUIToAddNewNote(event) {
    if (this.props.newNoteUiFunc) {
      this.props.newNoteUiFunc();
    } else {
      showAlert(this, 'Should now show a Modal for creating a new note');
    }
    event.stopPropagation();
  }

  createNoteSummaries(notes) {
    const sortedNotes = this.sort(notes);
    return (
      <div>
        {sortedNotes.map((note) => (
          <NoteSummary key={note.noteId} note={note} pageRerenderFunc={this.props.pageRerenderFunc} />
        ))}
      </div>
    );
  }

  sort(notes) {
    return notes.sort((n1, n2) => n2.date - n1.date);
  }

  render() {
    let { classes, notes } = this.props;
    notes = notes || [];
    return (
      <div>
        <AlertModal show={this.state.shouldShowAlertModal} renderer={this} text={this.state.alertModalText} />

        <div className={classes.entityAssocGroup}>
          <div className={classes.entityAssocGroup_header} onClick={() => this.toggleNotesVisibility()}>
            {this.props.newNoteUiFunc && (
              <div className={classes.quickAddToggle} onClick={(event) => this.showUIToAddNewNote(event)}>
                <div className={classes.addOneButton + ' ' + classes.button_icon}>
                  <i className="zmdi zmdi-plus" />
                </div>
              </div>
            )}
            <div className={classes.entityAssocGroup_title + ' ' + classes.ac_h4}>
              Notes ({notes.length})&nbsp;
              {notes.length ? (
                <i
                  className={cx(
                    classes.entityAssocGroup_expand,
                    'zmdi',
                    { 'zmdi-chevron-down': !this.state.showNoteSummaries },
                    { 'zmdi-chevron-up': this.state.showNoteSummaries }
                  )}
                />
              ) : null}
            </div>
          </div>
          {this.state.showNoteSummaries && this.createNoteSummaries(notes)}
        </div>
      </div>
    );
  }
}

export default withStyles(noteAssocGroupStyles)(NoteAssocGroup);
